// extracted by mini-css-extract-plugin
export default {"root-layout":"RootLayout_root-layout__LMgQI"};